<script>
import { mapActions } from 'vuex'

export default {
  name: 'table-settings',
  props: {

    fields: {
      type: Object,
      required: true,
    },
 
  },
  data: () => ({
    isLoading: false,
    fieldsSelected: [],
    filename: 'file_name_format',
    fileType: 'xlsx',
    itemsSelected: [],
    selectedTree: [],
    sheetLayout: 'trailer',
  }),
  computed: {
   
  },
  methods: {
   
  },
  mounted() {
  },
}
</script>

<template>
  <v-sheet class="default-dialog">

    <v-icon color="primary" @click="$emit('close')" class="close-btn"
      >mdi-close</v-icon
    >
  <v-card disabled >
    <v-card-title class="primary--text text-h4 d-flex flex-column align-start justify-start"> TABLE SETTINGS 

      <p class="primary--text text-body-1 text-left mb-0">
          <!-- (Disabled demo mode) -->
        </p>
    </v-card-title>
    <v-card-text class="pa-6">
      <v-row>
        <v-col cols="12" class="text-left">
          <p class="primary--text font-weight-bold text-body-1 mb-0">Field Mapping</p>
          <v-row v-for="(val, field) in fields" :key="field" color="transparent" dense  width="100%" >
            <v-col cols="4" class="d-flex align-center text-left "><p class="font-weight-bold text-body-2 mb-0">{{ field }}</p></v-col>
            <v-col cols="8" class="d-flex align-center text-left"> <v-text-field dense disabled hide-details outlined :value="val"></v-text-field></v-col>
            
           
          </v-row>
          
        </v-col>
      </v-row>
    </v-card-text>
    <!-- <v-card-actions>
      <v-btn color="warning" text>CANCEL</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="success" text>SAVE</v-btn>
  
    </v-card-actions> -->
  </v-card>
</v-sheet>

</template>

<style scoped></style>
